<div class="footer">
  © {{ year }} {{ siteConfig?.system?.name ?? '' }}. All rights reserved.
</div>
